import React from 'react';
import './styles.scss';

const Helpbox = (props) => {
  const {
    icon,
    iconStyles = {},
    iconSize = 20,
    boxStyles = {},
    children,
  } = props;

  const iconStyle = {
    backgroundImage: `url(${icon})`,
    backgroundSize: iconSize,
    width: iconSize,
    height: iconSize,
    ...iconStyles,
  };

  return (
    <div className="hover-element" style={iconStyle}>
      <p className="help-box" style={boxStyles}>{ children }</p>
    </div>
  );
};

export default Helpbox;
